import { assetworksData } from 'game-layers';
import { GamingRealms } from 'gaming-realms/gaming-realms';
import { SocialSetup } from 'setup/social-setup';

GamingRealms.go(new SocialSetup(), assetworksData, '/slingo/pressyourluck/games/');
